export const normalizeEmbeddedSignupSessionInfo = (data) => {
  if (!data) return null;

  if (Array.isArray(data)) {
    return data[0] || null;
  }

  return data;
};

export const extractEmbeddedSignupSessionInfoFromMessage = (event) => {
  if (!event?.data) return null;

  const allowedOrigins = ['https://www.facebook.com', 'https://web.facebook.com'];
  if (!allowedOrigins.includes(event.origin)) return null;

  let payload = event.data;

  if (typeof payload === 'string') {
    try {
      payload = JSON.parse(payload);
    } catch (error) {
      console.error('Failed to parse Embedded Signup message payload:', error);
      return null;
    }
  }

  if (payload?.action === 'whatsapp-account-onboarding' && payload?.shared_arguments) {
    payload = payload.shared_arguments;
  }

  const normalizedPayload = normalizeEmbeddedSignupSessionInfo(payload);
  if (!normalizedPayload?.data || !normalizedPayload?.event) {
    return null;
  }

  return normalizedPayload;
};

export const buildEmbeddedSignupSetup = (user = {}) => {
  const setup = {};

  const businessName =
    user?.businessName ||
    user?.storeName ||
    user?.accountName ||
    user?.name ||
    [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim() ||
    '';

  const businessEmail = user?.email || user?.businessEmail || user?.storeEmail || '';
  const businessWebsite = user?.businessWebsite || user?.storeWebsite || user?.website || '';
  const businessAddress = user?.businessAddress || user?.storeAddress || user?.address || '';
  const businessDescription = user?.businessDescription || user?.description || user?.about || '';
  const businessCountry = user?.businessCountry || user?.country || user?.storeCountry || 'US';

  if (businessName || businessEmail || businessWebsite || businessAddress) {
    setup.business = {};

    if (businessName) {
      setup.business.name = businessName;
    }

    if (businessEmail) {
      setup.business.email = businessEmail;
    }

    if (businessWebsite) {
      setup.business.website = businessWebsite;
    }

    if (businessAddress) {
      setup.business.address = {
        streetAddress1: businessAddress,
        country: businessCountry,
      };
    }
  }

  if (businessName || businessDescription) {
    setup.phone = {
      displayName: businessName || 'Business',
      category: 'OTHER',
      description: businessDescription || `Business profile for ${businessName || 'our business'}`,
    };
  }

  return setup;
};
